export default {
    transToLowerCase(data) {
        function getType(params) {
            return Object.prototype.toString.call(params).substring(8).replace(']', '')
        }

        function getKeys(obj, blank) {
            Object.keys(obj).forEach(key => {
                let low = key.replace(key[0], key[0].toLowerCase());
                let value = obj[key];
                let valueType = getType(value);
                if (valueType === 'Object') {
                    blank[low] = {};
                    getKeys(value, blank[low])
                } else if (valueType === 'Array') {
                    blank[low] = [];
                    getKeys(value, blank[low])
                } else {
                    blank[low] = value;
                    return blank
                }
            })
        }
        let blankObj = {};
        getKeys(data, blankObj)
        return blankObj;
    },
    transToUpperCase(data) {
        function getType(params) {
            return Object.prototype.toString.call(params).substring(8).replace(']', '')
        }

        function getKeys(obj, blank) {
            Object.keys(obj).forEach(key => {
                let low = key.replace(key[0], key[0].toUpperCase());
                let value = obj[key];
                let valueType = getType(value);
                if (valueType === 'Object') {
                    blank[low] = {};
                    getKeys(value, blank[low])
                } else if (valueType === 'Array') {
                    blank[low] = [];
                    getKeys(value, blank[low])
                } else {
                    blank[low] = value;
                    return blank
                }
            })
        }
        let blankObj = {};
        getKeys(data, blankObj)
        return blankObj;
    },
}


// WEBPACK FOOTER //
// ./src/tools/helper.js